import React, { useEffect } from 'react';
import './Team.css';
import { withStyles, makeStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';


const ColorButton = withStyles(() => ({
  root: {
    color: '#62310e',
    backgroundColor: '#5aa4b3',
    '&:hover': {
      backgroundColor: '#bbdad7',
    },
    textTransform: 'none',
  },
  label: {
    fontSize: '3vh',
  },
}))(Button);

const useStyles = makeStyles((theme) => ({
  margin: {
    margin: theme.spacing(1),
  },
}));

function Team() {

  useEffect(() => {
    document.querySelector('body').style.backgroundColor = '#cbe4c0'
  }, []);

  const classes = useStyles();

  return (
    <div className="TeamPage" >
      <h1 className="Title" >Team</h1>
      <h2>Team Leaders</h2>
      <div className='TeamCenter'>
        <p>Eldon Yellowhorn, Principal Investigator</p>
        <p>Angelica Lim, Co-Investigator</p>
      </div>
      <h2>Community Partners</h2>
      <div className='TeamCenter'>
        <a className='PartnerLink' href='https://piikani.ca/' target="_blank" rel="noreferrer">
          Peigan Board of Education
        </a>
        <p>Lisa Crowshoe, Superintendent</p>
        <p>Caroline Yellow Horn, Language Specialist</p>
      </div>
      <h2>Research Assistants</h2>
      <div className='TeamCenter'>
        <p>Anastasia Akkuzu</p>
        <p>Paige Tuttösí</p>
        <p>Roya Javadi</p>
        <p>Liyang Zhou</p>
        <p>Danny Yu</p>
        <p>Sunayani Sarkar</p>
        <p>Rachel Lagasse</p>
        <p>Gurnoor Chahal</p>
      </div>
      <h2>Art & Design</h2>
      <div className="TeamCenter">
        <p>
          Trista Townsend
        </p>
      </div>
      <div className='Button'>
        <ColorButton size="large" variant="contained" color="primary" className={classes.margin} href="https://www.surveymonkey.ca/r/N6XBHLY" target="_blank" rel="noreferrer" >
          Contact Us
        </ColorButton>
      </div>
    </div>
  );
}

export default Team;
